import React, { useState, useContext } from "react";
import NotificationContext from "../../../context/NotificationContext";
import Teaser from "../../../ui/Teaser/Teaser";
import {
  CpcChangeService,
  StatResetService,
  StatusChangeService,
  ShowTypeChangeService,
  SetPayoutService,
  SetGradeStatusService,
  copyTeasersMpaaRating
} from "../../../utils/api";

const TeaserComponent = ({ onChange, teaser, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [cpcError, setCpcError] = useState(false);
  const [cpcMode, setCpcMode] = useState("button");
  const notificationContext = useContext(NotificationContext);

  const showError = () => {
    notificationContext.showSimpleNotification({
      color: "red",
      title: "Ошибка",
      text: "Validation error"
    });
  };

  const onStatusChange = ({ tid, status }) => {
    setLoading(true);

    StatusChangeService({ tid, status })
      .then(() => {
        setLoading(false);
        onChange(teaser.id, { published: status });
      })
      .catch(e => {
        console.log(e);
      });
  };

  const onReloadClick = ({ tid }) => {
    setLoading(true);

    StatResetService({ tid })
      .then(() => {
        setLoading(false);
        onChange(teaser.id, { should_reset_stat: true });
      })
      .catch(e => {
        console.log(e);
      });
  };

  const onCpcChange = ({ tid, cpc }) => {
    setLoading(true);

    CpcChangeService({ tid, cpc })
      .then(() => {
        setLoading(false);
        setCpcError(false);
        setCpcMode("button");
        onChange(teaser.id, { cpc });
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
        setCpcError(true);
      });
  };

  const onShowTypeChange = ({ tid, type }) => {
    setLoading(true);

    ShowTypeChangeService({ tid, type })
      .then(() => {
        setLoading(false);

        onChange(teaser.id, { type });
      })
      .catch(e => {
        setLoading(false);
      });
  };

  const onCpcModeChange = mode => {
    setCpcMode(mode);
  };

  const onPaymentSelect = ({ tid, payoutStatus, payoutStatusOld, reasons }) => {
    setLoading(true);
    SetPayoutService({ tid, reasons, payoutStatus, payoutStatusOld })
      .then(data => {
        setLoading(false);

        onChange(teaser.id, { payout_status: payoutStatus });
      })
      .catch(e => {
        showError();
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onGradeChange = ({ tid, gradeStatus, gradeStatusOld }) => {
    setLoading(true);
    SetGradeStatusService({ tid, gradeStatus, gradeStatusOld })
      .then(data => {
        setLoading(false);
        onChange(teaser.id, { grade_status: gradeStatus });
      })
      .catch(e => {
        showError();
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleMpaaRatingChange = async ({ value: mpaa_rating }) => {
    try {
      setLoading(true);
      await copyTeasersMpaaRating({ ids: [teaser.id], mpaa_rating });
      onChange(teaser.id, { mpaa_rating });
    } catch (e) {
      showError();
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Teaser
      {...props}
      teaser={teaser}
      loading={loading}
      cpcError={cpcError}
      cpcMode={cpcMode}
      onCpcChange={onCpcChange}
      onCpcModeChange={onCpcModeChange}
      onStatusChange={onStatusChange}
      onReloadClick={onReloadClick}
      onShowTypeChange={onShowTypeChange}
      onPaymentSelect={onPaymentSelect}
      onGradeChange={onGradeChange}
      onMpaaRatingChange={handleMpaaRatingChange}
    />
  );
};

export default TeaserComponent;
